import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { fmtTime } from './Chat';

const API = process.env.REACT_APP_BACKEND_URL;

// Registrant list for the studio "People" tab.
export const RegistrationsList = ({ wid }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    const load = () => axios.get(`${API}/api/webinars/${wid}/registrations`).then((r) => setRows(r.data.items)).catch(() => setRows([]));
    load(); const t = setInterval(load, 15000); return () => clearInterval(t);
  }, [wid]);
  if (!rows) return <p className="py-6 text-center text-xs text-slate-400">Loading…</p>;
  return (
    <div className="min-h-0 flex-1 overflow-y-auto" data-testid="registrations-list">
      {rows.length === 0 && <p className="py-6 text-center text-xs text-slate-400">No registrations yet</p>}
      {rows.map((r) => (
        <div key={r.id} className="flex items-center gap-2 border-b border-slate-100 py-2 text-xs" data-testid={`registration-${r.id}`}>
          <div className="min-w-0 flex-1">
            <p className="truncate font-bold text-slate-900">{r.first_name} {r.last_name}</p>
            <p className="truncate text-slate-500 select-text">{r.email}{r.mobile ? ` · ${r.mobile}` : ''}</p>
          </div>
          <span className={`shrink-0 rounded-full px-2 py-0.5 font-bold ${r.joined_at ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-100 text-slate-500'}`}>
            {r.joined_at ? `Joined ${fmtTime(r.joined_at)} · ${Math.round((r.watch_seconds || 0) / 60)}m` : 'Not joined'}
          </span>
        </div>
      ))}
    </div>
  );
};
